import { StaticLogger } from '@nu-art/ts-common';
function isBrowser() {
    return typeof window !== 'undefined' && typeof window.atob === 'function';
}
export function convertBase64ToObject(base64) {
    try {
        // Check if running in the browser
        const decoded = isBrowser()
            ? window.atob(base64) // Browser: Use `atob`
            : Buffer.from(base64, 'base64').toString('utf-8'); // Node.js: Use `Buffer`
        return JSON.parse(decoded);
    }
    catch (err) {
        StaticLogger.logError(err);
        return {}; // Return an empty object of type T on failure
    }
}
export function convertObjectToBase64(object) {
    try {
        // Check if running in the browser
        const string = JSON.stringify(object);
        return isBrowser()
            ? window.btoa(string)
            : Buffer.from(string, 'utf-8').toString('base64');
    }
    catch (err) {
        StaticLogger.logError(err);
        return '';
    }
}
//# sourceMappingURL=base64-tools.js.map